<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-page v-if="currentItem" @page:afterin="afterin" @page:beforeout="beforeOut">
    <f7-navbar :title="`${currentItem.title}`" back-link="back"></f7-navbar>
    <element-path :path="currentElementPath" />

    <f7-list
      v-if="questions"
      sortable
      :sortable-enabled="true"
      @sortable:sort="onQuestionSort($event.detail.from - 1, $event.detail.to - 1)"
      no-hairlines-between
      style="margin: 0px 0px 0px 0px;">
      <f7-list-item group-title title="選項" />
      <f7-list-item
        v-for="(question, index) in questions"
        :key="`menu-drafts-questions-edit-${index}`"
        @click="showQuestionActions(question.id, index)">
        <span slot="title">{{ index + 1 }}. {{ question.title }}: ({{ $t(`questionType.${question.type}`) }})</span>
        <font-awesome-icon slot="after" icon="edit" style="color: #4CAF50; margin-right: 10px;" />
      </f7-list-item>
      <f7-button fill raised @click="showCreateQuestionActions" style="margin: 10px 10%;">新增選項</f7-button>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ElementPath from '@/components/ElementPath'

export default {
  dependencies: [
    'ImageUrlBuilder',
    'questionType'
  ],
  created () {
    this.pathLength = this.currentElementPath.length
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    itemId () { return this.currentElementPath[2].id },
    itemIndex () { return this.currentElementPath[2].index },
    questions () { return this.currentItem.questions.map(k => this.currentDraft.questions[k]) },
    currentItem () { return this.currentDraft.items[this.itemId] }
  },
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'setItemProperties']),
    afterin () {
      this.setCurrentElementPath(this.currentElementPath.slice(0, this.pathLength))
    },
    showQuestionActions (questionId, index) {
      this.setCurrentElementPath(this.currentElementPath.slice(0, 3).concat({ id: questionId, index }))
      this.$f7router.navigate(`/stores/${this.storeIdProp}/menu-drafts/${this.menuDraftVariationProp}/questions/${questionId}/question-actions`)
    },
    showCreateQuestionActions () {
      this.setCurrentElementPath(this.currentElementPath.slice(0, 3))
      this.$f7router.navigate(`/stores/${this.storeIdProp}/menu-drafts/${this.menuDraftVariationProp}/create-question-actions`)
    },
    onQuestionSort (from, to) {
      const questions = this.currentItem.questions.slice()
      questions.splice(to, 0, questions.splice(from, 1)[0])
      this.setItemProperties({ itemId: this.itemId, index: this.itemIndex, properties: { questions } })
    },
    beforeOut () {
      this.$f7.dialog.close()
    }
  },
  components: {
    ElementPath
  }
}
</script>
